// extracted by mini-css-extract-plugin
export default {"title":"TargetedTreatment_title__UXrSN","infoButton":"TargetedTreatment_infoButton__P0LFT"};